import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Select from "react-select";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

const FooterList = (props) => {
  const [characters, updateCharacters] = useState([]);
  const [options, setOptions] = useState(props.data);
  const [itemid, setItemId] = useState("");
  const [itemRef, setItemRef] = useState("");
  const footHeader = useFormInput("");

  const [newItem, setnewItem] = useState("");
  const [newSec, setnewSec] = useState("");

  const menuPic = [
    {
      value: "First Section",
      label: "First Section",
    },
    {
      value: "Second Section",
      label: "Second Section",
    },
    {
      value: "Third Section",
      label: "Third Section",
    },
  ];
  /* eslint-disable no-unused-vars */
  const [allIcon, setIcon] = useState(menuPic);
  const [itemSec, setItemSec] = useState("");
  /* eslint-disable no-unused-vars */
  /* const newContainer = (event)=>{
      event.preventDefault();
      const newer ={
        "value":"unnamedItem",
        "label":"unamedItem",
        "order":characters.length+1,
        "id":characters.length+1
      }
      updateCharacters([...characters, newer]);
      
    } */

  const checkValueExist = (value) => {
    return characters.some(function (el) {
      return el.value === value;
    });
  };

  const onChangeItem = (value) => {
    setItemId(value.value);
    setItemRef(value.label);
    setnewItem(value);
  };

  const onChangeSection = (value) => {
    setItemSec(value.value);
    setnewSec(value);
  };
  const newContainer = (event) => {
    event.preventDefault();

    const newer = {
      value: itemid,
      label: itemRef,
      order: characters.length + 1,
      id: itemid,
      section: newSec.value,
      header: footHeader.value,
    };

    if (characters.length < 12 && !checkValueExist(newer.value)) {
      updateCharacters([...characters, newer]);
      const newArray = [...characters, newer];
      props.onChange(newArray);
    } else {
      toastr.error("Limit Reached or item Already Exist", "Error");
    }
  };

  useEffect(() => {
    setOptions([...props.data]);

    const getDetails = () => {
      const opt = props.listData.map((item) => ({
        value: item.itemid,
        label: item.itemRef,
        order: item.itemOrder,
        id: item.itemid,
        section: item.itemSection,
        header: item.itemHeader,
      }));

      updateCharacters(opt);
    };

    getDetails();
  }, [props.data, props.listData]);
  const reorderArray = (items) => {
    const newItems = items.map((item, index) => {
      item.order = index + 1;
      return item;
    });
    updateCharacters(newItems);
    const newArr = newItems;
    props.onChange(newArr);
  };

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(characters);
    const [reorderedItem] = items.splice(result.source.index, 1);

    items.splice(result.destination.index, 0, reorderedItem);
    reorderArray(items);
  };

  const handleRemove = (event, index) => {
    const removeId = index;
    event.preventDefault();
    const items = Array.from(characters);
    items.splice(index, 1);

    reorderArray(items);
  };

  return (
    <div className="row mb-2 mt-2">
      <div className="col-sm-12">
        <div className="form-group">
          <div className="row">
            {props.dir === "rtl" && (
              <div className="col-md-2">
                <button
                  type="button"
                  className="btn btn-light btn-block"
                  style={{ width: "100px", marginTop: "8px", height: "40px" }}
                  onClick={newContainer}
                >
                  Add
                </button>
              </div>
            )}
            <div className="col-md-4" dir={props.dir === "rtl" ? "rtl" : "ltr"}>
              <label
                className={props.dir === "rtl" ? "float-right" : "float-left"}
              >
                Select Page
              </label>
              <Select
                name="containerList"
                className={
                  props.dir === "rtl"
                    ? "form-control inside-select float-right"
                    : "form-control inside-select float-left"
                }
                options={options}
                onChange={onChangeItem}
                value={newItem}
              ></Select>
            </div>
            <div className="col-md-3" dir={props.dir === "rtl" ? "rtl" : "ltr"}>
              <label
                className={props.dir === "rtl" ? "float-right" : "float-left"}
              >
                Section Header
              </label>
              <Select
                name="sectionList"
                className={
                  props.dir === "rtl"
                    ? "form-control inside-select float-right"
                    : "form-control inside-select float-left"
                }
                options={allIcon}
                onChange={onChangeSection}
                value={newSec}
              ></Select>
            </div>
            <div className="col-md-3">
              <label
                className={props.dir === "rtl" ? "float-right" : "float-left"}
              >
                Footer Header
              </label>
              <input
                dir={props.dir === "rtl" ? "rtl" : "ltr"}
                type="text"
                name="footerHeader"
                className="form-control inside-form"
                placeholder="Footer Header ..."
                {...footHeader}
                autoComplete="off"
              />
            </div>

            {!(props.dir === "rtl") && (
              <div className="col-md-2">
                <button
                  type="button"
                  className="btn btn-light btn-block"
                  style={{ width: "100px", marginTop: "8px", height: "40px" }}
                  onClick={newContainer}
                >
                  Add
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-12">
        <DragDropContext onDragEnd={handleOnDragEnd}>
          <Droppable droppableId={"characters"}>
            {(provided) => (
              <ul
                className="products-list product-list-in-card pl-2 pr-2"
                {...provided.droppableProps}
                ref={provided.innerRef}
                style={{ maxHeight: "350px", overflowY: "scroll" }}
              >
                {characters.map((item, index) => (
                  <Draggable
                    key={item.id + item.order}
                    draggableId={"item" + item.id}
                    index={index}
                  >
                    {(provided) => (
                      <li
                        className="item"
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <div className="product-info">
                          <a
                            href={"/item/" + item.value + "/" + item.id}
                            className="product-title"
                          >
                            {item.label}
                            <span className="badge badge-warning float-left">
                              {item.order}
                            </span>
                          </a>
                          <div
                            className="text-right"
                            style={{ display: "inline", float: "right" }}
                          >
                            <a
                              className="btn btn-light btn-sm"
                              href="#!"
                              onClick={(event) => handleRemove(event, index)}
                            >
                              <i className="fas fa-trash"></i>
                            </a>
                          </div>
                          <span
                            className="product-description"
                            style={{ marginLeft: "55px" }}
                          >
                            {item.section}
                          </span>
                        </div>
                      </li>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </ul>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </div>
  );
};

const useFormInput = (initialValue) => {
  const [value, setValue] = useState(initialValue);

  const handleChange = (e) => {
    setValue(e.target.value);
  };
  return {
    value,
    onChange: handleChange,
  };
};

export default FooterList;
